import { render, staticRenderFns } from "./RelatedAudio.vue?vue&type=template&id=9eed598e&scoped=true&"
import script from "./RelatedAudio.vue?vue&type=script&lang=js&"
export * from "./RelatedAudio.vue?vue&type=script&lang=js&"
import style0 from "./RelatedAudio.vue?vue&type=style&index=0&id=9eed598e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eed598e",
  null
  
)

export default component.exports